module.exports = __webpack_public_path__ + "static/media/landing.80b54aa6.png";